import React, { useCallback, useEffect, useMemo, useState } from "react";

import MainLayout from "../components/mainLayout";

import { api } from "../api";

import "../sass/pages/gestaoPontoScreen.scss";

import SelectFuncionario from "../components/ui/selectFuncionario.jsx";

// util

const pad2 = (n) => String(n).padStart(2, "0");

const isHHmm = (v) =>

  v === "" || /^([01]\d|2[0-3]):[0-5]\d$/.test(String(v || ""));

const CAMPOS = [

  { key: "EntradaManha", label: "Entrada Manhã" },

  { key: "SaidaManha", label: "Saída Manhã" },

  { key: "EntradaTarde", label: "Entrada Tarde" },

  { key: "SaidaTarde", label: "Saída Tarde" },

  { key: "EntradaExtra", label: "Entrada Extra" },

  { key: "SaidaExtra", label: "Saída Extra" },

];

function getStatus(row) {

  if (!row) return { text: "Sem registro", cls: "semregistro" };

  const em = (row.EntradaManha || "").trim();

  const sm = (row.SaidaManha || "").trim();

  const et = (row.EntradaTarde || "").trim();

  const st = (row.SaidaTarde || "").trim();

  const completo = !!em && !!sm && !!et && !!st;

  const temAlgo =

    !!em ||

    !!sm ||

    !!et ||

    !!st ||

    !!(row.EntradaExtra || "").trim() ||

    !!(row.SaidaExtra || "").trim();

  if (completo) return { text: "Completo", cls: "completo" };

  if (temAlgo) return { text: "Pendente", cls: "pendente" };

  return { text: "Sem registro", cls: "semregistro" };

}

function getFilenameFromDisposition(disposition) {

  if (!disposition) return null;

  const m = /filename\*?=(?:UTF-8'')?("?)([^";]+)\1/i.exec(disposition);

  return m?.[2] ? decodeURIComponent(m[2]) : null;

}

function decodeArrayBufferToText(buf) {

  try {

    return new TextDecoder("utf-8").decode(new Uint8Array(buf));

  } catch {

    return "";

  }

}

function downloadArrayBuffer({ data, contentType, filename }) {

  const blob = new Blob(

    [data],

    { type: contentType || "application/octet-stream" }

  );

  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");

  a.href = url;

  a.download = filename || "download";

  document.body.appendChild(a);

  a.click();

  a.remove();

  window.URL.revokeObjectURL(url);

}

function firstDayOfMonth(year, month) {

  return `${year}-${String(month).padStart(2, "0")}-01`;

}

function lastDayOfMonth(year, month) {

  return new Date(year, month, 0).toISOString().slice(0, 10);

}

function resolveCodFunc(obj) {

  return (

    Number(obj?.CodFunc_New ?? obj?.CodFunc ?? obj?.IdFuncionario ?? obj?.id) ||

    null

  );

}

function resolveCodCadFunc(obj) {

  return Number(obj?.CodCadFunc ?? obj?.CodCad ?? obj?.CodCad_New) || null;

}

function resolveNomeFunc(obj) {

  return String(obj?.Nome ?? obj?.NomeFunc ?? obj?.Usuario ?? "").trim() || "Funcionário";

}

function getExtByFormato(formato) {

  const fmt = String(formato || "").toUpperCase();

  if (fmt === "PDF") return "pdf";

  if (fmt === "XLSX") return "xlsx";

  if (fmt === "TXT") return "txt";

  return "csv";

}

function getAcceptHeaderByFormato(formato) {

  const fmt = String(formato || "").toUpperCase();

  if (fmt === "PDF") return "application/pdf, application/octet-stream";

  if (fmt === "XLSX") {

    return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream";

  }

  if (fmt === "TXT") {

    return "text/plain, application/octet-stream";

  }

  return "text/csv, application/octet-stream";

}

/* =========================

   Modal

========================= */

function Modal({ open, title, message, kind = "info", details, onClose }) {
  const [copiado, setCopiado] = useState(false);
  useEffect(() => { if (open) setCopiado(false); }, [open, details, message]);
  if (!open) return null;

  const isApuracao = title === "Prévia da apuração Domínio";
  const cls = `gp-modal ${kind === "error" ? "is-error" : kind === "success" ? "is-success" : ""} ${isApuracao ? "is-apuracao" : ""}`;
  const linhas = String(details || "").split(/\r?\n/).map(v => v.trim()).filter(Boolean);
  const resumo = isApuracao ? linhas.filter(v => /^(Eventos apurados|Pendências):/i.test(v)) : [];
  const eventos = isApuracao ? linhas.filter(v => v.startsWith("Funcionário interno")) : [];
  const pendencias = isApuracao ? linhas.filter(v => v.startsWith("PENDENTE:")) : [];
  const erroComPendencias = !isApuracao && /^Exportação bloqueada:\s*\d+ pendência/i.test(String(message || ""));
  const erroLinhas = erroComPendencias
    ? String(message).replace(/^Exportação bloqueada:\s*(\d+ pendência\(s\))\.\s*/i, 'Exportação bloqueada: $1\n').split(/;\s*(?=[^;]+\d{4}-\d{2}-\d{2})/).map(v => v.trim()).filter(Boolean)
    : [];
  const textoCopiar = [title, message, details && !erroComPendencias ? details : null].filter(Boolean).join("\n\n");
  const copiar = async () => {
    try {
      if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(textoCopiar);
      else {
        const temp = document.createElement("textarea");
        temp.value = textoCopiar;
        temp.style.position = "fixed";
        temp.style.opacity = "0";
        document.body.appendChild(temp);
        temp.select();
        if (!document.execCommand("copy")) throw new Error("Cópia não permitida");
        temp.remove();
      }
      setCopiado(true);
    } catch (err) { console.error("Falha ao copiar:", err); setCopiado(false); }
  };

  return (
    <div className={cls} role="dialog" aria-modal="true" aria-label={title || "Aviso"} onMouseDown={e => { if (e.target === e.currentTarget) onClose?.(); }}>
      <div className="gp-modal__backdrop" />
      <div className="gp-modal__panel">
        <div className="gp-modal__title">
          <div className="gp-modal__h">{title || "Aviso"}</div>
          <button className="gp-modal__close" onClick={onClose} type="button">Fechar</button>
        </div>
        <div className="gp-modal__body">
          {isApuracao ? (
            <>
              <p className="gp-modal__desc">{message}</p>
              <div className="gp-modal__resumo">{resumo.map((v, i) => <span key={i} className="gp-modal__badge">{v}</span>)}</div>
              <section className="gp-modal__section">
                <h3>Eventos apurados ({eventos.length})</h3>
                {eventos.length ? <ol className="gp-modal__lista">{eventos.map((v,i) => <li key={i}>{v}</li>)}</ol> : <p>Nenhum evento encontrado.</p>}
              </section>
              <section className="gp-modal__section">
                <h3>Pendências ({pendencias.length})</h3>
                {pendencias.length ? <ol className="gp-modal__lista gp-modal__lista--pendencias">{pendencias.map((v,i) => <li key={i}>{v.replace(/^PENDENTE:\s*/, "")}</li>)}</ol> : <p>Sem pendências.</p>}
              </section>
            </>
          ) : erroComPendencias ? (
            <section className="gp-modal__section">
              <h3>{erroLinhas[0]}</h3>
              <p className="gp-modal__desc">Corrija ou classifique as ocorrências antes de exportar o TXT.</p>
              <ol className="gp-modal__lista gp-modal__lista--pendencias">{erroLinhas.slice(1).map((v,i) => <li key={i}>{v}</li>)}</ol>
            </section>
          ) : (
            <>
              <div className="gp-modal__desc">{message || "Sem mensagem."}</div>
              {details && <pre className="gp-modal__pre" title="Detalhes técnicos">{details}</pre>}
            </>
          )}
        </div>
        <div className="gp-modal__actions">
          <button className="gp-modal__copy" onClick={copiar} type="button" aria-live="polite">{copiado ? "Copiado!" : "Copiar conteúdo"}</button>
          <button className="gp-modal__confirm" onClick={onClose} type="button">OK</button>
        </div>
      </div>
    </div>
  );
}

const TOUR_STORAGE_KEY = "gestao-ponto-rh-tour-v1";

const TOUR_STEPS = [
  { selector: '[data-gp-tour="funcionario"]', title: "1. Escolha um funcionário", description: "Pesquise e selecione quem terá os registros conferidos. Para exportar vários funcionários, utilize a fila de exportação." },
  { selector: '[data-gp-tour="competencia"]', title: "2. Defina a competência", description: "Selecione mês e ano do ponto que será conferido. Os dados da tabela são atualizados para esse período." },
  { selector: '[data-gp-tour="tabela"]', title: "3. Confira os registros", description: "Selecione um dia na tabela para visualizar as batidas. Os dias sem registro ou incompletos precisam de atenção do RH." },
  { selector: '[data-gp-tour="detalhe"]', title: "4. Corrija as marcações", description: "Depois de selecionar um dia, edite o horário necessário. Informe uma justificativa e salve. O tutorial não altera registros por conta própria." },
  { selector: '[data-gp-tour="fila"]', title: "5. Defina quem será exportado", description: "Adicione funcionários à fila ou marque todos com registros no mês. Confira o escopo antes de exportar." },
  { selector: '[data-gp-tour="layout"]', title: "6. Escolha o leiaute Domínio", description: "Selecione 43 ou 48 posições conforme orientação do contador. O formato das horas é horas/minutos." },
  { selector: '[data-gp-tour="previa"]', title: "7. Confira a apuração", description: "Veja horas extras, rubricas e pendências. Copie o relatório caso precise solicitar correções." },
  { selector: '[data-gp-tour="exportar"]', title: "8. Gere o TXT para o contador", description: "TXT Contador exige a resolução das pendências; TXT com pendências exporta apenas eventos considerados seguros. Informe ao contador quando enviar um arquivo parcial." },
  { selector: '[data-gp-tour="historico"]', title: "9. Consulte o histórico", description: "Veja quais versões foram geradas. O histórico não significa que o arquivo foi importado pelo contador; cuidado com reenvios." },
];

function TourRH({ step, onClose, onBack, onNext }) {
  const [rect, setRect] = useState(null);
  const [pos, setPos] = useState(null);
  const etapa = TOUR_STEPS[step];

  useEffect(() => {
    if (!etapa) return undefined;
    const target = document.querySelector(etapa.selector);
    if (!target) return undefined;
    let raf = 0;
    const update = () => {
      const r = target.getBoundingClientRect();
      const pad = 7;
      const x = Math.max(8, r.left - pad);
      const y = Math.max(8, r.top - pad);
      const w = Math.min(window.innerWidth - x - 8, r.width + 2 * pad);
      const h = Math.min(window.innerHeight - y - 8, r.height + 2 * pad);
      setRect({ left: x, top: y, width: Math.max(0,w), height: Math.max(0,h) });
      const cardWidth = Math.min(410, window.innerWidth - 24);
      const cardHeight = 260;
      const below = r.bottom + 18;
      const top = below + cardHeight < window.innerHeight ? below : Math.max(12, r.top - cardHeight - 16);
      setPos({ top: Math.max(12, Math.min(window.innerHeight - cardHeight - 12, top)), left: Math.max(12, Math.min(window.innerWidth - cardWidth - 12, r.left)), width: cardWidth });
    };
    target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    const refresh = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); };
    update();
    const timer = setTimeout(refresh, 450);
    window.addEventListener('resize', refresh);
    window.addEventListener('scroll', refresh, true);
    return () => { clearTimeout(timer); cancelAnimationFrame(raf); window.removeEventListener('resize',refresh); window.removeEventListener('scroll',refresh,true); };
  }, [etapa]);

  useEffect(() => {
    const key = e => { if(e.key === 'Escape') onClose(); if(e.key === 'ArrowRight') onNext(); if(e.key === 'ArrowLeft') onBack(); };
    document.addEventListener('keydown', key);
    return () => document.removeEventListener('keydown', key);
  }, [onClose, onNext, onBack]);

  if (!etapa || !rect || !pos) return null;
  return (
    <div className="gp-tour" role="dialog" aria-modal="true" aria-label="Tutorial de gestão de ponto">
      <div className="gp-tour__dim" />
      <div className="gp-tour__focus" style={rect} aria-hidden="true" />
      <div className="gp-tour__card" style={pos}>
        <div className="gp-tour__meta"><span>GUIA RÁPIDO · RH</span><span>{step + 1} de {TOUR_STEPS.length}</span></div>
        <div className="gp-tour__progress" aria-hidden="true"><span style={{ width: `${(step + 1) / TOUR_STEPS.length * 100}%` }} /></div>
        <h2>{etapa.title}</h2>
        <p>{etapa.description}</p>
        <div className="gp-tour__buttons">
          <button type="button" className="gp-tour__skip" onClick={onClose}>Pular tutorial</button>
          <button type="button" onClick={onBack} disabled={step === 0}>Voltar</button>
          <button type="button" className="gp-tour__next" onClick={onNext}>{step === TOUR_STEPS.length - 1 ? 'Concluir' : 'Próximo'}</button>
        </div>
      </div>
    </div>
  );
}

export default function GestaoPontoScreen() {

  const [tourStep, setTourStep] = useState(null);
  const encerrarTour = useCallback(() => { setTourStep(null); try { localStorage.setItem(TOUR_STORAGE_KEY, "1"); } catch (_) {} }, []);
  const proximoTour = useCallback(() => setTourStep((s) => { if (s === null) return null; if (s >= TOUR_STEPS.length - 1) { try { localStorage.setItem(TOUR_STORAGE_KEY, "1"); } catch (_) {} return null; } return s + 1; }), []);
  const anteriorTour = useCallback(() => setTourStep((s) => s === null ? null : Math.max(0, s - 1)), []);
  useEffect(() => {
    try { if (localStorage.getItem(TOUR_STORAGE_KEY) !== "1") { const t = setTimeout(() => setTourStep(0), 700); return () => clearTimeout(t); } } catch (_) { /* Armazenamento indisponível */ }
  }, []);

  const now = new Date();

  const [func, setFunc] = useState(null);

  // competência

  const [mes, setMes] = useState(pad2(now.getMonth() + 1));

  const [ano, setAno] = useState(String(now.getFullYear()));

  // dados mês

  const [loading, setLoading] = useState(false);

  const [rowsMes, setRowsMes] = useState([]);

  const [diaSel, setDiaSel] = useState(null);

  // edição no detalhe

  const [edit, setEdit] = useState({ campo: null, valor: "" });

  const [justificativa, setJustificativa] = useState("");

  const [saving, setSaving] = useState(false);

  // export

  const [exporting, setExporting] = useState(false);
  const [layoutDominio, setLayoutDominio] = useState("43");

  const [selectedExportFuncs, setSelectedExportFuncs] = useState([]);

  const [exportAllMonth, setExportAllMonth] = useState(false);

  // modal

  const [modal, setModal] = useState({

    open: false,

    title: "",

    message: "",

    kind: "info",

    details: "",

  });

  const openModal = useCallback((title, message, kind = "info", details = "") => {

    setModal({ open: true, title, message, kind, details });

  }, []);

  const closeModal = useCallback(() => {

    setModal((s) => ({ ...s, open: false }));

  }, []);

  // resolve ids

  const codFunc = resolveCodFunc(func);

  const codCadFunc = resolveCodCadFunc(func);

  const nomeFunc = resolveNomeFunc(func);

  const totalDias = useMemo(() => {

    const y = Number(ano);

    const m = Number(mes);

    if (!y || !m) return 0;

    return new Date(y, m, 0).getDate();

  }, [mes, ano]);

  const mapByDia = useMemo(() => {

    const mp = new Map();

    for (const r of rowsMes) {

      const d = Number(r.Dia);

      if (!Number.isFinite(d)) continue;

      if (!mp.has(d)) mp.set(d, r);

    }

    return mp;

  }, [rowsMes]);

  const dias = useMemo(() => {

    const y = Number(ano);

    const m = Number(mes);

    if (!y || !m || !totalDias) return [];

    return Array.from({ length: totalDias }, (_, i) => {

      const dia = i + 1;

      const dt = new Date(y, m - 1, dia);

      const dow = dt.getDay();

      const row = mapByDia.get(dia) || null;

      const status = getStatus(row);

      return {

        dia,

        isWeekend: dow === 0 || dow === 6,

        row,

        status,

      };

    });

  }, [ano, mes, totalDias, mapByDia]);

  const diaAtual = useMemo(() => {

    if (!diaSel) return null;

    return dias.find((d) => d.dia === diaSel) || null;

  }, [dias, diaSel]);

  const getErrMsg = useCallback((e) => {

    const d = e?.response?.data;

    if (d && typeof d === "object") {

      return d?.mensagem || d?.message || d?.error || "Erro desconhecido";

    }

    return e?.message || "Erro desconhecido";

  }, []);

  const loadMes = useCallback(async () => {

    if (!codFunc) return;

    setLoading(true);

    try {

      const { data } = await api.get(`/ponto/${codFunc}`, {

        params: { mes, ano, page: 1, limit: 500 },

      });

      setRowsMes(Array.isArray(data?.data) ? data.data : []);

    } catch (e) {

      console.error(e);

      setRowsMes([]);

      openModal("Falha", "Falha ao carregar mês.", "error", getErrMsg(e));

    } finally {

      setLoading(false);

    }

  }, [codFunc, mes, ano, openModal, getErrMsg]);

  useEffect(() => {

    setDiaSel(null);

    setEdit({ campo: null, valor: "" });

    if (codFunc) loadMes();

    else setRowsMes([]);

  }, [codFunc, mes, ano, loadMes]);

  const startEdit = useCallback(

    (campo) => {

      if (!diaAtual) return;

      const current = String(diaAtual?.row?.[campo] || "").slice(0, 5);

      setEdit({ campo, valor: current });

    },

    [diaAtual]

  );

  const cancelEdit = useCallback(() => setEdit({ campo: null, valor: "" }), []);

  const addFuncionarioToExport = useCallback(() => {

    if (!codFunc) {

      openModal("Atenção", "Selecione um funcionário antes de adicionar.", "info");

      return;

    }

    setSelectedExportFuncs((prev) => {

      const exists = prev.some((x) => x.codFunc === codFunc);

      if (exists) return prev;

      return [

        ...prev,

        {

          codFunc,

          codCadFunc: codCadFunc || null,

          nome: nomeFunc,

        },

      ];

    });

    openModal(

      "Seleção atualizada",

      `Funcionário "${nomeFunc}" adicionado à fila de exportação.`,

      "success"

    );

  }, [codFunc, codCadFunc, nomeFunc, openModal]);

  const removeFuncionarioFromExport = useCallback((cod) => {

    setSelectedExportFuncs((prev) => prev.filter((x) => x.codFunc !== cod));

  }, []);

  const clearExportSelection = useCallback(() => {

    setSelectedExportFuncs([]);

    setExportAllMonth(false);

  }, []);

  const save = useCallback(async () => {

    if (!codFunc) return openModal("Atenção", "Selecione um funcionário.", "info");

    if (!diaSel) return openModal("Atenção", "Selecione um dia.", "info");

    if (!edit.campo) return;

    const h = String(edit.valor || "").trim();

    if (!isHHmm(h)) {

      return openModal("Validação", "Hora inválida. Use HH:mm.", "info");

    }

    if (!String(justificativa || "").trim()) {

      return openModal("Validação", "Justificativa é obrigatória.", "info");

    }

    setSaving(true);

    try {

      let existente = null;

      try {

        const vr = await api.get(

          `/ponto/verifica/${codFunc}/${diaSel}/${Number(mes)}/${Number(ano)}`

        );

        existente = vr?.data || null;

      } catch {

        existente = null;

      }

      const payloadUpsert = {

        NomeFunc: nomeFunc,

        CodFunc: codFunc,

        CodCadFunc: codCadFunc || null,

        dia: Number(diaSel),

        mes: Number(mes),

        ano: Number(ano),

        campo: edit.campo,

        hora: h,

        motivo: String(justificativa).trim(),

        ajustadoPor:

          sessionStorage.getItem("Usuario") ||

          sessionStorage.getItem("login") ||

          "web",

      };

      if (existente?.ID) {

        try {

          await api.patch(`/ponto/ajustar/${existente.ID}`, {

            ajustes: { [edit.campo]: h },

            justificativa: String(justificativa).trim(),

          });

        } catch (ePatch) {

          console.error("PATCH falhou, fallback PUT /ponto/ajustar:", ePatch);

          await api.put(`/ponto/ajustar`, payloadUpsert);

        }

      } else {

        await api.put(`/ponto/ajustar`, payloadUpsert);

      }

      cancelEdit();

      await loadMes();

      openModal("Sucesso", "Ajuste aplicado com sucesso.", "success");

    } catch (e) {

      console.error(e);

      openModal("Falha", `Falha ao salvar ajuste: ${getErrMsg(e)}`, "error");

    } finally {

      setSaving(false);

    }

  }, [

    codFunc,

    diaSel,

    edit.campo,

    edit.valor,

    justificativa,

    mes,

    ano,

    nomeFunc,

    codCadFunc,

    cancelEdit,

    loadMes,

    openModal,

    getErrMsg,

  ]);

  const carregarFuncionariosComRegistroNoMes = useCallback(async () => {

    const mm = Number(mes);

    const yy = Number(ano);

    const dtIni = firstDayOfMonth(yy, mm);

    const dtFim = lastDayOfMonth(yy, mm);

    let page = 1;

    const limit = 500;

    let total = 0;

    const collected = [];

    do {

      const { data } = await api.get(`/ponto/gestao`, {

        params: {

          dtIni,

          dtFim,

          page,

          limit,

        },

      });

      const rows = Array.isArray(data?.data) ? data.data : [];

      total = Number(data?.total || 0);

      collected.push(...rows);

      page += 1;

    } while ((page - 1) * limit < total);

    const uniq = new Map();

    for (const r of collected) {

      const cod = Number(r?.CodFunc);

      if (!Number.isFinite(cod)) continue;

      if (!uniq.has(cod)) {

        uniq.set(cod, {

          codFunc: cod,

          nome: String(r?.NomeFunc || `Funcionário ${cod}`).trim(),

        });

      }

    }

    return Array.from(uniq.values());

  }, [mes, ano]);

  const exportar = useCallback(

    async (formato, previsualizar = false, modalidade = "COMPLETA") => {

      setExporting(true);

      try {

        const fmt = String(formato || "PDF").toUpperCase();

        const ext = getExtByFormato(fmt);

        let funcionariosIds = [];

        let rotuloExportacao = "";

        if (exportAllMonth) {

          const lista = await carregarFuncionariosComRegistroNoMes();

          funcionariosIds = lista

            .map((x) => Number(x.codFunc))

            .filter(Number.isFinite);

          rotuloExportacao = `Todos os funcionários com registro em ${mes}/${ano}`;

          if (!funcionariosIds.length) {

            throw new Error(

              `Nenhum funcionário com registro encontrado em ${mes}/${ano}.`

            );

          }

        } else {

          funcionariosIds = selectedExportFuncs

            .map((x) => Number(x.codFunc))

            .filter(Number.isFinite);

          if (!funcionariosIds.length && codFunc) {

            funcionariosIds = [Number(codFunc)];

            rotuloExportacao = nomeFunc;

          } else if (funcionariosIds.length === 1) {

            const achado = selectedExportFuncs.find(

              (x) => Number(x.codFunc) === funcionariosIds[0]

            );

            rotuloExportacao = achado?.nome || `CodFunc ${funcionariosIds[0]}`;

          } else {

            rotuloExportacao = `${funcionariosIds.length} funcionário(s)`;

          }

          if (!funcionariosIds.length) {

            return openModal(

              "Atenção",

              "Selecione um funcionário, adicione à fila de exportação ou marque a opção de todos do mês.",

              "info"

            );

          }

        }

        const payload = {


          formato: fmt,
          previsualizar: fmt === "TXT" && previsualizar,
          modalidade: fmt === "TXT" ? modalidade : undefined,

          tipo: "MES",

          mes: Number(mes),

          ano: Number(ano),

          funcionarios: funcionariosIds,

          modelo: "CONTADOR",

        };

        const resp = await api.post(`/ponto/exportar`, payload, {

          responseType: "arraybuffer",

          headers: {

            Accept: getAcceptHeaderByFormato(fmt),

          },

        });

        if (previsualizar && fmt === "TXT") {
          const decoded = decodeArrayBufferToText(resp.data);
          const resultado = JSON.parse(decoded);
          const a = resultado?.apuracao || {};
          const linhas = [
            `Leiaute: ${layoutDominio} posições | Horas:minutos`,
             `Eventos apurados: ${(a.lancamentos || []).length}`,
            `Pendências: ${(a.pendencias || []).length}`,
            ...(a.lancamentos || []).map(x => `Funcionário interno ${x.codFunc} · Rubrica ${x.rubrica} · ${x.quantidade}${x.data ? ` · ${x.data}` : ""}`),
            ...(a.pendencias || []).map(x => `PENDENTE: ${x}`),
          ];
          openModal("Prévia da apuração Domínio", "Confira os eventos e resolva todas as pendências antes de gerar o TXT.", (a.pendencias || []).length ? "info" : "success", linhas.join("\n"));
          return;
        }

        const contentType =

          resp?.headers?.["content-type"] || "application/octet-stream";

        const filename =

          getFilenameFromDisposition(resp?.headers?.["content-disposition"]) ||

          `ponto_${ano}-${mes}_${exportAllMonth ? "todos" : funcionariosIds.join("-")}.${ext}`;

        downloadArrayBuffer({

          data: resp.data,

          contentType,

          filename,

        });

        openModal(

          "Exportação concluída",

          `Arquivo gerado e baixado com sucesso.\nModalidade: ${fmt === "TXT" ? modalidade : "RELATÓRIO"}\nFormato: ${fmt}\nLeiaute: ${fmt === "TXT" ? `${layoutDominio} posições / horas:minutos` : "Não se aplica"}\nEscopo: ${rotuloExportacao}\nCompetência: ${mes}/${ano}\nModelo: CONTADOR`,

          "success"

        );

      } catch (e) {

        console.error(e);

        let details = "";

        let msg = "Erro ao exportar ponto.";

        const buf = e?.response?.data;

        if (buf instanceof ArrayBuffer) {

          details = decodeArrayBufferToText(buf);

          try {

            const parsed = JSON.parse(details);

            msg = parsed?.mensagem || parsed?.message || parsed?.error || msg;

          } catch {

            if (details?.trim()) {

              msg = details.slice(0, 500);

            } else {

              msg = getErrMsg(e);

            }

          }

        } else {

          msg = getErrMsg(e);

        }

        openModal("Falha", msg, "error", details);

      } finally {

        setExporting(false);

      }

    },

    [

      codFunc,

      mes,

      ano,

      nomeFunc,

      exportAllMonth,

      selectedExportFuncs,

      carregarFuncionariosComRegistroNoMes,

      layoutDominio,

       openModal,

      getErrMsg,

    ]

  );

  const canExport =

    !exporting &&

    (exportAllMonth || selectedExportFuncs.length > 0 || Boolean(codFunc));

  return (

    <MainLayout>

      {tourStep !== null && <TourRH step={tourStep} onClose={encerrarTour} onBack={anteriorTour} onNext={proximoTour} />}

      <Modal

        open={modal.open}

        title={modal.title}

        message={modal.message}

        kind={modal.kind}

        details={modal.details}

        onClose={closeModal}

      />

      <div className="gestao-ponto-page">

        <div className="gp-header">

          <div className="gp-title">

            <h1>Gestão de Ponto</h1>
            <button type="button" className="gp-tour-launch" onClick={() => setTourStep(0)}>Como usar esta tela?</button>

            <div className="gp-sub">

              Ajuste administrativo de horários por dia e exportação por competência.

            </div>

          </div>

          <div className="gp-actions">

            <button

              className="btn-small"

              onClick={loadMes}

              disabled={!codFunc || loading}

            >

              {loading ? "Carregando..." : "Recarregar"}

            </button>

            <label data-gp-tour="layout" style={{display:"inline-flex",alignItems:"center",gap:6,fontSize:12,fontWeight:700,whiteSpace:"nowrap"}}>
              Leiaute Domínio
              <select value={layoutDominio} onChange={e => setLayoutDominio(e.target.value)}
                disabled={exporting} aria-label="Leiaute de exportação Domínio"
                style={{height:36,border:"1px solid #c5cfdd",borderRadius:8,padding:"0 8px",background:"#fff"}}>
                <option value="43">43 posições</option>
                <option value="48">48 posições</option>
              </select>
            </label>
            <div className="gp-export-group">

              <button
                className="btn-small"
                data-gp-tour="previa"
                onClick={() => exportar("TXT", true)}
                disabled={!canExport}
                title="Prévia dos eventos e pendências de apuração"
              >
                Conferir apuração
              </button>

              <button

                className="btn-small btn-export-txt"

                data-gp-tour="exportar"
                onClick={() => exportar("TXT", false, "COMPLETA")}

                disabled={!canExport}

                title="Exportar TXT para o contador"

              >

                {exporting ? "Exportando..." : "TXT Contador"}

              </button>

              <button
                className="btn-small btn-export-txt"
                onClick={() => {
                  if (window.confirm("Gerar TXT PARCIAL? Apenas eventos apurados sem pendências no respectivo dia serão incluídos. Pendências não resolvidas ficarão fora do arquivo; informe o contador.")) {
                    exportar("TXT", false, "COM_PENDENCIAS");
                  }
                }}
                disabled={!canExport}
                title="TXT no leiaute Domínio com apenas eventos seguros"
              >TXT com pendências</button>
              <button data-gp-tour="historico" className="btn-small" disabled={exporting} onClick={async () => {
                try {
                  const {data} = await api.get('/ponto/exportacoes-dominio', {params:{competencia:`${ano}${pad2(mes)}`}});
                  const linhas = (data?.data || []).map(x=>`V${x.ID} | ${x.MODALIDADE} | ${x.QT_EVENTOS} eventos | ${x.QT_PENDENCIAS} pendências | ${new Date(x.DTHR_GERACAO).toLocaleString('pt-BR')} | ${x.USUARIO_GERACAO}`);
                  openModal('Histórico de exportações Domínio', `Competência ${mes}/${ano}. Arquivos gerados não significam arquivos importados pelo contador.`, 'info', linhas.join('\n') || 'Nenhuma exportação registrada.');
                } catch(e) {openModal('Falha', getErrMsg(e), 'error');}
              }}>Histórico</button>
              <button className="btn-small" disabled title="Depende de validação do procedimento de retificação no Domínio">Complementar (bloqueada)</button>

              <button

                className="btn-small"

                onClick={() => exportar("XLSX")}

                disabled={!canExport}

                title="Exportar XLSX"

              >

                {exporting ? "Exportando..." : "Exportar XLSX"}

              </button>

              <button

                className="btn-primary"

                onClick={() => exportar("PDF")}

                disabled={!canExport}

                title="Exportar PDF"

              >

                {exporting ? "Exportando..." : "Exportar PDF"}

              </button>

            </div>

          </div>

        </div>

        <div className="gp-filters card">

          <div className="gp-row">

            <div className="field grow">

              <label data-gp-tour="funcionario">Funcionário</label>

              <SelectFuncionario value={func} onChange={setFunc} />

              <div className="muted" style={{ fontWeight: 700 }}>

                {codFunc

                  ? `CodFunc: ${codFunc}`

                  : "Selecione um funcionário para carregar o mês."}

              </div>

            </div>

            <div className="field inline">

              <label data-gp-tour="competencia">Mês</label>

              <select value={mes} onChange={(e) => setMes(e.target.value)}>

                {Array.from({ length: 12 }, (_, i) => {

                  const mm = pad2(i + 1);

                  return (

                    <option key={mm} value={mm}>

                      {mm}

                    </option>

                  );

                })}

              </select>

            </div>

            <div className="field inline">

              <label>Ano</label>

              <select value={ano} onChange={(e) => setAno(e.target.value)}>

                {Array.from({ length: 6 }, (_, i) => {

                  const yy = String(now.getFullYear() - i);

                  return (

                    <option key={yy} value={yy}>

                      {yy}

                    </option>

                  );

                })}

              </select>

            </div>

            <div className="field grow">

              <label>Justificativa (obrigatória)</label>

              <input

                value={justificativa}

                onChange={(e) => setJustificativa(e.target.value)}

                placeholder="Ex.: ajuste autorizado pelo ADM / solicitação formal"

                disabled={!codFunc}

              />

            </div>

          </div>

          <div className="gp-row" style={{ marginTop: 12, alignItems: "flex-start" }}>

            <div className="field grow">

              <label data-gp-tour="fila">Fila de exportação</label>

              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 8 }}>

                <button

                  type="button"

                  className="btn-small"

                  onClick={addFuncionarioToExport}

                  disabled={!codFunc || exportAllMonth}

                >

                  Adicionar funcionário atual

                </button>

                <button

                  type="button"

                  className="btn-small"

                  onClick={clearExportSelection}

                  disabled={!selectedExportFuncs.length && !exportAllMonth}

                >

                  Limpar seleção

                </button>

                <label

                  style={{

                    display: "inline-flex",

                    alignItems: "center",

                    gap: 8,

                    fontWeight: 700,

                    cursor: "pointer",

                  }}

                >

                  <input

                    type="checkbox"

                    checked={exportAllMonth}

                    onChange={(e) => setExportAllMonth(e.target.checked)}

                  />

                  Todos com registro em {mes}/{ano}

                </label>

              </div>

              {!selectedExportFuncs.length ? (

                <div className="muted" style={{ fontWeight: 700 }}>

                  Nenhum funcionário adicionado à fila.

                </div>

              ) : (

                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>

                  {selectedExportFuncs.map((item) => (

                    <div

                      key={item.codFunc}

                      style={{

                        display: "inline-flex",

                        alignItems: "center",

                        gap: 8,

                        padding: "6px 10px",

                        borderRadius: 999,

                        border: "1px solid #d6d6d6",

                        background: "#fff",

                      }}

                    >

                      <span style={{ fontWeight: 700 }}>

                        {item.nome} ({item.codFunc})

                      </span>

                      <button

                        type="button"

                        className="btn-small"

                        onClick={() => removeFuncionarioFromExport(item.codFunc)}

                        disabled={exportAllMonth}

                      >

                        Remover

                      </button>

                    </div>

                  ))}

                </div>

              )}

              <div className="muted" style={{ marginTop: 8, fontWeight: 700 }}>

                Escopo atual da exportação:{" "}

                {exportAllMonth

                  ? `todos com registro em ${mes}/${ano}`

                  : selectedExportFuncs.length

                  ? `${selectedExportFuncs.length} funcionário(s) na fila`

                  : codFunc

                  ? `funcionário atual (${nomeFunc})`

                  : "nenhum selecionado"}

              </div>

            </div>

          </div>

        </div>

        <section className="card gp-dominio" aria-label="Integração Domínio">
          <h2>Exportação para a folha Domínio</h2>
          <p className="muted">Empresa 40 · Folha mensal · Horas:minutos. Os códigos dos funcionários são obtidos automaticamente do cadastro.</p>
          <p className="muted">Clique em <strong>Conferir apuração</strong> para visualizar os eventos calculados a partir das batidas e da jornada cadastrada. A exportação só é liberada quando não houver pendências. Feriados, folgas, ausências e DSR exigem classificação/aprovação do RH; percentuais e dias úteis devem seguir a política validada pelo contador.</p>
        </section>

        <div className="gp-grid">

          <div className="card gp-table" data-gp-tour="tabela">

            <div className="gp-table__meta">

              <div>

                Competência <b>{mes}/{ano}</b>

              </div>

              <div className="muted">

                {loading ? "Carregando..." : `Dias: ${totalDias} | Registros: ${rowsMes.length}`}

              </div>

            </div>

            {!codFunc ? (

              <div className="muted" style={{ fontWeight: 800, padding: 10 }}>

                Selecione um funcionário.

              </div>

            ) : (

              <div className="gp-table__scroll">

                <table>

                  <thead>

                    <tr>

                      <th>Dia</th>

                      <th>Status</th>

                      <th>Ent. Manhã</th>

                      <th>Saí. Manhã</th>

                      <th>Ent. Tarde</th>

                      <th>Saí. Tarde</th>

                      <th>Ent. Extra</th>

                      <th>Saí. Extra</th>

                    </tr>

                  </thead>

                  <tbody>

                    {dias.map((d) => (

                      <tr

                        key={d.dia}

                        className={[

                          d.isWeekend ? "row-weekend" : "",

                          diaSel === d.dia ? "row-selected" : "",

                        ].join(" ")}

                        onClick={() => {

                          setDiaSel(d.dia);

                          cancelEdit();

                        }}

                        style={{ cursor: "pointer" }}

                      >

                        <td>{pad2(d.dia)}/{mes}</td>

                        <td>

                          <span className={`badge ${d.status.cls}`}>

                            {d.status.text}

                          </span>

                        </td>

                        <td>{d.row?.EntradaManha || "-"}</td>

                        <td>{d.row?.SaidaManha || "-"}</td>

                        <td>{d.row?.EntradaTarde || "-"}</td>

                        <td>{d.row?.SaidaTarde || "-"}</td>

                        <td>{d.row?.EntradaExtra || "-"}</td>

                        <td>{d.row?.SaidaExtra || "-"}</td>

                      </tr>

                    ))}

                  </tbody>

                </table>

              </div>

            )}

          </div>

          <div className="card gp-side" data-gp-tour="detalhe">

            <div className="gp-side__title">Detalhe / Ações</div>

            {!diaAtual ? (

              <div className="muted" style={{ fontWeight: 800 }}>

                Selecione um dia na tabela.

              </div>

            ) : (

              <>

                <div className="gp-side__day">

                  Dia <b>{pad2(diaAtual.dia)}/{mes}/{ano}</b>

                  <span

                    className={`badge ${diaAtual.status.cls}`}

                    style={{ marginLeft: 10 }}

                  >

                    {diaAtual.status.text}

                  </span>

                </div>

                <div className="gp-side__list">

                  {CAMPOS.map((f) => {

                    const val = String(diaAtual.row?.[f.key] || "").slice(0, 5);

                    const editing = edit.campo === f.key;

                    return (

                      <div key={f.key} className={`gp-item ${editing ? "is-editing" : ""}`}>

                        <div className="gp-item__left">

                          <div className="gp-item__label">{f.label}</div>

                        </div>

                        <div className="gp-item__mid">

                          {editing ? (

                            <input

                              type="time"

                              value={edit.valor}

                              onChange={(e) =>

                                setEdit((s) => ({ ...s, valor: e.target.value }))

                              }

                              disabled={saving}

                            />

                          ) : (

                            <div className="gp-item__value">{val || "-"}</div>

                          )}

                        </div>

                        <div className="gp-item__right">

                          {!editing ? (

                            <button

                              className="btn-small"

                              onClick={() => startEdit(f.key)}

                              disabled={!codFunc}

                            >

                              Ajustar

                            </button>

                          ) : (

                            <div className="gp-actions-inline">

                              <button

                                className="btn-primary"

                                onClick={save}

                                disabled={saving}

                              >

                                {saving ? "Salvando..." : "Salvar"}

                              </button>

                              <button

                                className="btn-small"

                                onClick={cancelEdit}

                                disabled={saving}

                              >

                                Cancelar

                              </button>

                            </div>

                          )}

                        </div>

                      </div>

                    );

                  })}

                </div>

                <div className="muted" style={{ marginTop: 10, fontWeight: 800 }}>

                  Governança: justificativa obrigatória. Se existir ID no dia → PATCH

                  (auditoria). Se falhar → fallback PUT. Se não existir → PUT (cria).

                </div>

              </>

            )}

          </div>

        </div>

      </div>

    </MainLayout>

  );

}
